import { render, staticRenderFns } from "./select-product-input.vue?vue&type=template&id=4952be95&scoped=true"
import script from "./select-product-input.vue?vue&type=script&lang=js"
export * from "./select-product-input.vue?vue&type=script&lang=js"
import style0 from "./select-product-input.vue?vue&type=style&index=0&id=4952be95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952be95",
  null
  
)

export default component.exports